import React, {useEffect, useMemo, useState} from 'react';
import {Footer} from '../ui';
import {ToastContainer} from 'react-toastify';
import {CartContextProvider} from '../cart';
import {NotificationContextProvider} from '../notification/contexts/NotificationContext';
import {UserContextProvider} from '../user/infrastructure/UserContext';
import {Outlet, useNavigate} from 'react-router-dom';
import {useAuthenticator} from '@aws-amplify/ui-react';
import {fetchAuthSession} from '@aws-amplify/auth';
import {NavbarComposer} from '../high-order-context/NavbarComposer';
import {FilterContextProvider} from "../features/catalog/infrastructure/FilterContext";
import {useInitialFilters} from "../features/catalog/application/useInitialFilters";

const PrivatePage = () => {
    const {user} = useAuthenticator(context => [context.user]);
    const navigate = useNavigate();
    const [shouldLoadPage, setShouldLoadPage] = useState();


    useEffect(() => {
        if (shouldLoadPage === false) {
            window.location.href = '/iniciar-sesion';
        }
    }, [shouldLoadPage, navigate]);

    useEffect(() => {
        const isAuthenticated = async () => {
            if (!!user) {
                return setShouldLoadPage(true);
            }
            const session = await fetchAuthSession();
            return setShouldLoadPage(!!session?.userSub);
        };

        isAuthenticated();
    }, [user]);

    const initialFilters = useInitialFilters();

    if (shouldLoadPage) {
        return (
            <UserContextProvider>
                <CartContextProvider>
                    <NotificationContextProvider>
                        <FilterContextProvider initialFilters={initialFilters}>
                            <div className="d-flex flex-column gap-3 min-vh-100">
                                <ToastContainer position="top-center"/>

                                <header>
                                    <NavbarComposer/>
                                </header>

                                <main className="container flex-fill">
                                    <Outlet/>
                                </main>
                                <Footer className="mt-auto"/>
                            </div>
                        </FilterContextProvider>
                    </NotificationContextProvider>
                </CartContextProvider>
            </UserContextProvider>
        );
    } else {
        return <></>;
    }
};

export default PrivatePage;
